import { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { FaExclamationCircle, FaSpinner, FaCheckCircle } from "react-icons/fa";

import logo from "../../assets/images/logo.png";
import "../Login/style.css";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (!username.trim()) {
      setError("Lütfen kullanıcı adınızı giriniz.");
      return;
    }

    setIsLoading(true);

    try {
      // TODO: API call buraya gelecek
      await new Promise((resolve) => setTimeout(resolve, 1500)); // Simüle edilmiş API çağrısı
      
      setSuccess(true);
      setShow(true);
      setUsername("");
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="login-wrapper">
        <div className="login-container">
          <div className="logo-section">
        <div className="logo">
              <img src={logo} alt="Viva Smart Care Logo" />
            </div>
            <h3>Viva Smart Care</h3>
            <p className="subtitle">Şifre Yenileme</p>
          </div>

          <Form className="form-wrapper" onSubmit={handleSubmit}>
            {error && (
              <div className="error-message" role="alert">
                <FaExclamationCircle className="error-icon" />
                <span>{error}</span>
                <button
                  type="button"
                  className="error-close"
                  onClick={() => setError("")}
                  aria-label="Hata mesajını kapat"
                >
                  ×
                </button>
              </div>
            )}

            <Form.Group className="form-group">
              <label htmlFor="username">Kullanıcı Adı</label>
              <div className="input-wrapper">
                <Form.Control
                  id="username"
                  type="text"
                  placeholder="Kullanıcı adınızı giriniz"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isLoading}
                  required
                  autoComplete="username"
                  className={error && !username ? "error" : ""}
                />
        </div>
          </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="login-button"
            >
              {isLoading ? (
                <>
                  <FaSpinner className="button-spinner" />
                  Gönderiliyor...
                </>
              ) : (
                "Aktivasyon Linki Gönder"
              )}
            </Button>

            <div className="signup-link">
              <Link to={"/login"} className="back-link">
                ← Giriş Sayfasına Dön
              </Link>
            </div>
          </Form>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {success ? (
              <>
                <FaCheckCircle style={{ color: "#48bb78", marginRight: "8px" }} />
                Başarılı
              </>
            ) : (
              "Bilgi"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ marginBottom: 0 }}>
            {success
              ? "Mail adresinize aktivasyon kodu başarılı bir şekilde gönderilmiştir. İşleminize mail adresinizden devam edebilirsiniz."
              : "Bir hata oluştu. Lütfen tekrar deneyin."}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Tamam
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ForgotPassword;
